import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Search as SearchIcon } from "lucide-react";
import { api } from "../lib/api";
import Seo from "../components/Seo";

const GROUPS = [["programs", "Programlar"], ["content", "Kütüphane"], ["products", "Mağaza"], ["events", "Etkinlikler"]];

export default function Search() {
  const [params, setParams] = useSearchParams();
  const q = params.get("q") || "";
  const [term, setTerm] = useState(q);
  const [res, setRes] = useState(null);

  useEffect(() => {
    setTerm(q);
    if (q.trim().length < 2) { setRes(null); return; }
    api.get("/search", { params: { q } }).then(({ data }) => setRes(data)).catch(() => setRes({}));
  }, [q]);

  const total = res ? GROUPS.reduce((n, [k]) => n + (res[k]?.length || 0), 0) : 0;
  const submit = (e) => { e.preventDefault(); setParams(term.trim() ? { q: term.trim() } : {}); };

  return (
    <>
      <Seo title="Arama" description="Bilgece içerik, program, ürün ve etkinliklerde arayın." />
      <section className="pt-36 pb-12 bg-brand-green text-brand-offwhite grain relative overflow-hidden">
        <div className="container-narrow px-6 lg:px-10">
          <p className="text-xs uppercase tracking-[0.25em] text-brand-gold font-semibold mb-4">Arama</p>
          <h1 className="font-serif text-4xl md:text-6xl font-light">Ne arıyorsunuz?</h1>
          <form onSubmit={submit} className="mt-8 flex max-w-2xl bg-brand-offwhite rounded-sm overflow-hidden">
            <input autoFocus value={term} onChange={(e) => setTerm(e.target.value)} data-testid="search-input" placeholder="Program, yazı, ürün veya etkinlik..." className="flex-1 px-5 py-4 text-brand-text outline-none bg-transparent min-w-0" />
            <button type="submit" data-testid="search-submit" className="bg-brand-gold text-brand-offwhite px-6 inline-flex items-center gap-2 hover:bg-brand-gold/90 transition-colors"><SearchIcon size={18} /> <span className="hidden sm:inline">Ara</span></button>
          </form>
        </div>
      </section>
      <section className="py-14 px-6 sm:px-10 lg:px-16 bg-brand-offwhite min-h-[40vh]">
        <div className="container-narrow">
          {!res && <p data-testid="search-hint" className="text-brand-text/60">Aramak için en az 2 karakter yazın.</p>}
          {res && <p data-testid="search-total" className="text-brand-text/70 mb-10">"{q}" için {total} sonuç bulundu.</p>}
          {res && GROUPS.map(([k, label]) => res[k]?.length > 0 && <Group key={k} k={k} label={label} items={res[k]} />)}
        </div>
      </section>
    </>
  );
}

function Group({ k, label, items }) {
  return (
    <div data-testid={`search-group-${k}`} className="mb-12">
      <h2 className="font-serif text-2xl text-brand-green mb-5">{label} <span className="text-brand-gold text-base">({items.length})</span></h2>
      <div className="grid sm:grid-cols-2 gap-4">
        {items.map((it) => (
          <Link key={it.url} to={it.url} data-testid={`search-result-${k}-${it.slug}`} className="flex gap-4 bg-brand-cream border border-brand-gold-light/40 rounded-sm p-3 hover:border-brand-gold hover:-translate-y-0.5 transition-transform duration-300">
            {it.image ? <img src={it.image} alt="" className="w-20 h-20 object-cover rounded-sm flex-shrink-0" /> : <div className="w-20 h-20 bg-brand-gold-light/30 rounded-sm flex-shrink-0" />}
            <div className="min-w-0">
              <p className="font-medium text-brand-green line-clamp-2">{it.title}</p>
              <p className="text-sm text-brand-text/60 mt-1 line-clamp-2">{it.subtitle}</p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
